
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/atlas/review-and-apply",
      function () {
        return require("private-next-pages/docs/atlas/review-and-apply.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/atlas/review-and-apply"])
      });
    }
  